export enum FAQType {
  Question = 'q',
  Answer = 'a',
}

export type FAQSectionKey =
  | 'help_cat_general'
  | 'help_cat_payments'
  | 'help_cat_inGame'
  | 'help_cat_account'
  | 'help_cat_refunds'

export const faqs = [
  {
    sectionKey: 'help_cat_general',
    ids: [4, 5, 1, 2, 3, 6] as const,
  },
  {
    sectionKey: 'help_cat_payments',
    ids: [7, 11, 10, 9, 14, 12] as const,
  },
  {
    sectionKey: 'help_cat_inGame',
    ids: [16, 17, 18] as const,
  },
  {
    sectionKey: 'help_cat_refunds',
    ids: [19, 22, 23] as const,
  },
] satisfies { sectionKey: FAQSectionKey; ids: readonly number[] }[]

export type FAQSection = (typeof faqs)[number]
export type FAQIds = FAQSection['ids']
export type FAQId = FAQIds[number]
